
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 81.25 81.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64.17 68.44c-1.35-10-8.64-18.3-17.92-20.73a13.15 13.15 0 007.71-12.08 13.33 13.33 0 10-19 12.08 25 25 0 00-17.87 20.73 36.46 36.46 0 1147.08 0zM31.42 35.63a9.17 9.17 0 119.17 9.17 9.18 9.18 0 01-9.17-9.17zM21.05 71.36c.31-10.83 9.27-20.22 19.58-20.22s19.27 9.38 19.58 20.21a36.37 36.37 0 01-39.16 0zM40.63 0a40.63 40.63 0 1040.62 40.63A40.68 40.68 0 0040.63 0z","fill":"#444"}})])
          )
        }
      }
    